<template>
<div>
   <div v-if="$store.state.isSafariBrowser &&  ref == 'iosApp'"  :height="m_h"  :width="m_w" style="font-size:50px;color:white">

     返回游戏
  </div>
  <div v-else>
    <div id="home" class="home">
    <div class="closeServiceBtn" @click="fanhui" v-if="xcxnb">
        <img src="../../assets/img/fanhui.png" alt="" />
    </div>
    <iframe
      :src="url"
      :height="m_h"
      allowtransparency="yes"
      scrolling="no"
      frameborder="0"
      :width="m_w"
      style="overflow: hidden"
      id="h5-game-iframe"
    ></iframe>
    <div
      class="logoIcon"
      :class="{ logoIcon_opacity: isLgoOpacity }"
      @click="openTopWin"
      id="MotionButton"
    >
      <img :src="logoIcon" />
    </div>
    <!-- 遮罩层 -->
    <div
      class="maskInfo"
      v-if="
        $store.state.winType.isUserInfoMask ||
        $store.state.winType.isLoginBox ||
        $store.state.winType.isRegister ||
        $store.state.winType.isAccountAndPas ||
        $store.state.winType.isTips ||
        $store.state.winType.isCouponInfo ||
        $store.state.winType.isReconiseInfo ||
        $store.state.winType.isBindPhone ||
        $store.state.winType.isAlertPwd ||
        $store.state.winType.isPayType ||
        $store.state.winType.isPayUrlInfo ||
        $store.state.winType.isFindPwd ||
        $store.state.winType.isUserMsgProtect ||
        $store.state.winType.isReconiseInfoTip ||
        $store.state.winType.isLogoutAccount
      "
    >

    <div class="closeServiceBtn" @click="fanhui" v-if="xcxnb">
            <img src="../../assets/img/fanhui.png" alt="" />
          </div>

          <!-- 总窗口 -->
          <userInfoMask v-if="$store.state.winType.isUserInfoMask" />
          <userMsgProtect v-if="$store.state.winType.isUserMsgProtect" />
          <reconiseInfoTip v-if="$store.state.winType.isReconiseInfoTip" />
          <loginBox v-if="$store.state.winType.isLoginBox" />
          <register v-if="$store.state.winType.isRegister" />
          <accountAndPas v-if="$store.state.winType.isAccountAndPas" />
          <coupon v-if="$store.state.winType.isCouponInfo" />

          <reconiseInfo v-if="$store.state.winType.isReconiseInfo" />
          <bindPhone v-if="$store.state.winType.isBindPhone" />
          <alertPwd v-if="$store.state.winType.isAlertPwd" />
          <findPwd v-if="$store.state.winType.isFindPwd" />
          <payType
            :pay-info="payInfo"
            v-if="
              $store.state.winType.isPayType || $store.state.winType.isPayUrlInfo
            "
          />
          <logoutAccount v-if="$store.state.winType.isLogoutAccount" />
        </div>
        <div
          class="safari-float"
          :class="$store.state.isSafariBrowser ? 'isSafari-browser' : ''"
          v-if="$store.state.visibleGuideFloat && ref != 'sys' && ref != 'iosApp' && !isWeb"
          @click="downloadApk"
        >
          <img class="safari-logo" :src="$store.state.gameIconUrl" alt="" />
          <!-- safari -->
          <div class="safari-tips" v-if="$store.state.isSafariBrowser">
            <p>先点击<img src="../../assets/img/share.png" /></p>
            <p>再“添加到主屏幕”<img src="../../assets/img/add.png" alt="" /></p>
          </div>
          <!-- android -->
          <div class="safari-tips" v-else>
            <p>点击下载</p>
            <p>游戏端到手机</p>
          </div>
          <div class="safari-close" @click.stop="closeSafariFloat($event)">
            <img :src="close" alt="" />
          </div>
        </div>
        <!-- 客服聊天窗 -->
        <div v-if="$store.state.winType.isShowService" class="serviceWin">
          <div class="closeServiceBtn" @click="closeService">
            <img src="../../assets/img/closeIcon.png" alt="" />
          </div>
          <iframe
            :src="$store.state.serviceUrl"
            frameborder="0"
            :width="m_w"
          ></iframe>
        </div>
        </div>

    </div>
  </div>

</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js"></script>

<script>
import wx from "weixin-js-sdk";
import Clipboard from "clipboard";
import { hex_md5 } from "@/common/js/md5.js";
import fun from "@/common/js/common";

import userInfoMask from "./userInfoMask";
import userMsgProtect from "./userMsgProtect";
import reconiseInfoTip from "./reconiseInfoTip";
import loginBox from "./loginBox";
import accountAndPas from "./accountAndPas";
import coupon from "./coupon";

import reconiseInfo from "./reconiseInfo";
import bindPhone from "./bindPhone";
import payType from "./payType";
import register from "./register";
import alertPwd from "./alertPwd";
import findPwd from "./findPwd";
import logoutAccount from "./logoutAccount";

export default {
  name: "inner",
  inject: ["reload"], //注入App里的reload方法
  props: [""],

  components: {
    userInfoMask,
    userMsgProtect,
    reconiseInfoTip,
    loginBox,
    accountAndPas,
    reconiseInfo,
    bindPhone,
    payType,
    register,
    alertPwd,
    findPwd,
    coupon,
    logoutAccount,
  },

  data() {
    return {
      xcxnb: false,
      showInfo: "",
      isOldReg: null,
      isWeb: false,
      ref: "user",
      payInfo: "", // 支付弹窗展示信息
      logoIcon: require("../../assets/img/new2/logo.png"),
      close: require("../../assets/img/close.png"),
      url: "", // iframe游戏路径
      m_h: "", // iframe高度
      m_w: "", // iframe宽度
      userInfo: "", // 用户信息
      adid: "",
      sign: "", // 签名
      firstLoad: true,
      isCloseWinShow: "", //提示弹窗开关
      model: "",
      serviceInfo: {},
      isUserFCM: "", //用户是否实名过
      timmer: null,
      guideTimeout: 60,
      isReportRoleInfo: false,
      downloadApkUrl: "",
      isLgoOpacity: false,
    };
  },
  created() {


    var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res) => {
              if (res.miniprogram) {
                  this.xcxnb=true;

              }
          })
    }

    this.browserRedirect();
    var _this = this;
    var MobileDetect = require("mobile-detect");
    var device_type = navigator.userAgent; //获取userAgent信息
    var md = new MobileDetect(device_type); //初始化mobile-detect
    var os = md.os(); //获取系统
    if (os == "AndroidOS") {
      //Android系统的处理
      os = md.os() + md.version("Android");
      var sss = device_type.split(";");
      var i = fun.getModel(sss, "Build/");
      if (i > -1) {
        this.model = sss[i]
          .substring(0, sss[i].indexOf("Build/"))
          .replace("-", "");
      }
    }
    this.h5_screen_orientation();
    this.getSize();
    document.addEventListener("DOMContentLoaded", _this.getSize, false);
    window.addEventListener("resize", function () {
      setTimeout(function () {
        _this.h5_screen_orientation();
      }, 1000);

      _this.getSize();
    });
    addEventListener("load", _this.getSize, false);
  },
  mounted() {
    var _this = this;
    this.ref = localStorage.getItem("ref");
    window.localStorage.removeItem("serviceInfo");
    var time = new Date().getTime();
    this.userInfo = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {};
    this.downloadApkUrl = localStorage.getItem("downloadApkUrl")
      ? localStorage.getItem("downloadApkUrl")
      : {};

    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");

    this.showInfo = localStorage.getItem("showInfo")
      ? JSON.parse(localStorage.getItem("showInfo"))
      : {};
    let userMsgProtect = localStorage.getItem("userMsgProtect") || "";
    if (this.showInfo.showPermissionView == 0 && userMsgProtect != "1") {
      this.$store.dispatch("IsUserMsgProtectFun", true);
      return false;
    } else {
      if (!this.userInfo.uid) {
        //未登陆
        let show = false;
        if (
          this.showInfo != null &&
          this.showInfo.firstPage != null &&
          this.showInfo.firstPage != undefined
        ) {
          if (this.showInfo.firstPage == 0) {
            this.isOldReg = localStorage.getItem("isOldReg");
            if (
              this.isOldReg == null ||
              this.isOldReg == "" ||
              this.isOldReg == "null" ||
              this.isOldReg == undefined
            ) {
              this.$store.dispatch("IsRegisterFun", true);
            } else if (this.isOldReg == this.adid) {
              this.$store.dispatch("IsLoginBoxFun", true);
            } else {
              this.$store.dispatch("IsRegisterFun", true);
            }
          } else if (
            this.showInfo.firstPage == 1 ||
            this.showInfo.firstPage == 2
          ) {
            this.$store.dispatch("IsLoginBoxFun", true); //登陆页面在同一文件需要再在文件中判断
          } else {
            this.$store.dispatch("IsLoginBoxFun", true);
          }
        } else {
          this.$store.dispatch("IsLoginBoxFun", true);
        }
      } else {
      }
    }
    window.onmessage = function (e) {
      if (e.data.reportType === "cp_pay") {
        // 监听支付
        _this.$store.dispatch("IsPayTypeFun", true);

        _this.payInfo = e.data;
      } else if (e.data.reportType === "cp_role") {
        // 监听角色信息上报
        localStorage.setItem("serviceInfo", JSON.stringify(e.data));
        if (_this.userInfo.uid) {
          //  if (_this.isReportRoleInfo && _this.userInfo.uid) {
          _this.roleInfo = e.data;
          _this.reportRoleInfo(e.data);
          localStorage.setItem("roleInfo", JSON.stringify(e.data));
        }
      }
    };
    // 时间戳

    this.dragmover();
    this.url =
      fun.apiUrl +
      "game/login?uid=" +
      (this.userInfo.uid ? this.userInfo.uid : time) +
      "&adid=" +
      this.adid +
      "&time=" +
      time +
      "&sign=" +
      "&os=ios";
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, document.URL);
      window.addEventListener("popstate", _this.backChange, false); // false阻止默认事件
    }
    if (!this.isLgoOpacity) {
      setTimeout(() => {
        _this.isLgoOpacity = true;
      }, 5000);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.backChange, false);
  },
  beforeDestroy() {
    var _this = this;
    clearInterval(_this.timmer); // 清除定时器
    _this.timmer = null;
  },
  watch: {
    isLgoOpacity(val) {
      let _this = this;
      if (!val) {
        setTimeout(() => {
          _this.isLgoOpacity = true;
        }, 5000);
      }
    },
  },
  methods: {
    fanhui(){
      console.log("小程序返回")
 // 这里退回到上一级页面, 也就是刚刚跳转前的页面
    wx.miniProgram.navigateBack({})
    },
    // 关闭客服聊天窗口
    closeService() {
      this.$store.dispatch("IsServiceFun", false);
    },
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();

      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          sUserAgent
        )
      ) {
        this.isWeb = false;
        //跳转移动端页面
        return true;
      } else {
        this.isWeb = true;
        //跳转pc端页面
        return false;
      }
    },
    //监听微信返回按钮
    backChange() {
      var _this = this;
      history.pushState(null, null, document.URL);
      if (_this.firstLoad) {
        _this.firstLoad = false;
      } else {
        _this.isCloseWinShow = true;
      }
    },
    //根据屏幕宽和高获取iframe高度
    h5_screen_orientation() {
      if (localStorage.getItem("deskIcon") && window.screen.availHeight) {
        // this.m_h =
        //   window.screen.availHeight ||
        //   window.innerHeight ||
        //   document.documentElement.clientHeight;

        this.m_h = window.innerHeight || document.documentElement.offsetHeight;
      } else {
        this.m_h = window.innerHeight || document.documentElement.clientHeight;
      }
      this.m_w = window.innerWidth || document.documentElement.clientWidth;
    },
    //点击浮标打开总弹窗
    openTopWin() {
      // if (this.userInfo.uid && this.userInfo.bindPhone == "1") {
      //   this.postRedStatus();
      // }
      this.$store.dispatch("IsUserInfoMaskFun", true);
      this.isLgoOpacity = false;
    },
    //退出游戏
    outGame() {
      window.location.href = "about:blank";
      wx.closeWindow();
    },

    //继续游戏
    goOnGame() {
      this.isCloseWinShow = false;
    },
    // 安卓下载
    downloadApk() {
      if (this.$store.state.isSafariBrowser) {
        return;
      }
      location.href = JSON.parse(this.downloadApkUrl);
    },
    // 关闭显示safari提示添加到主屏提示
    closeSafariFloat(e) {
      e.stopPropagation();
      this.$store.commit("postVisibleGuideFloatr", false);

      // 定时显示引导
      setTimeout(
        function () {
          this.$store.commit("postVisibleGuideFloatr", true);
        }.bind(this),
        this.guideTimeout * 1000
      );
    },
    reportRoleInfo(data) {
      this.isReportRoleInfo = false;
      var data = {
        adid: this.adid,
        ip: this.ipAdress,
        os: this.os,
        dataType: this.roleInfo.type,
        uid: this.userInfo.uid,
        serverid: this.roleInfo.serverId,
        serverName: this.roleInfo.serverName,
        roleId: this.roleInfo.roleId,
        roleName: this.roleInfo.roleName,
        roleLevel: this.roleInfo.roleLevel,
        moneyNum: this.roleInfo.totalCurrency,
        totalCurrency: this.roleInfo.totalCurrency,
        roleCreateTime: this.roleInfo.roleCreateTime,
        power: this.roleInfo.power,
        vip: this.roleInfo.vip ? this.roleInfo.vip : "0",
      };
      this.$http.post(fun.apiUrl + "api/member/getUserInfo", data).then(
        function (res) {
          this.isReportRoleInfo = true;
        },
        function (res) {
          this.$toast.text(res.body.msg);
        }
      );
    },

    dragmover() {
      var _this = this;
      var flag = 0;
      var motion = document.getElementById("MotionButton");
      var disX, disY; //元素左/上 ‘半径’
      var moveX, moveY;
      var L, T; //可移动范围
      var starX, starY;
      var starXEnd, starYEnd;

      motion.addEventListener("touchstart", function (e) {
        flag = 0;
        e.preventDefault(); //阻止触摸按钮时页面滚动和缩放
        //获取元素左/上边到中心（clientX,clientY）的距离
        disX = e.touches[0].clientX - this.offsetLeft;
        disY = e.touches[0].clientY - this.offsetTop;
        //手指按下屏幕时的坐标
        starX = e.touches[0].clientX;
        starY = e.touches[0].clientY;
      });
      motion.addEventListener("touchmove", function (e) {
        L = e.touches[0].clientX - disX;
        T = e.touches[0].clientY - disY;
        //移动时当前位置和起始位置的差值
        starXEnd = e.touches[0].clientX - starX;
        starYEnd = e.touches[0].clientY - starY;
        if (Math.abs(starXEnd) > 0 || Math.abs(starYEnd) > 0) {
          flag = 1;
        }
        if (L < 0) {
          L = 0; //限制拖拽的X范围，不能拖出屏幕
        } else if (
          L >
          document.documentElement.clientWidth - this.offsetWidth
        ) {
          L = document.documentElement.clientWidth - this.offsetWidth;
        }
        if (T < 0) {
          T = 0; //限制拖拽的Y范围，不能拖出屏幕
        } else if (
          T >
          document.documentElement.clientHeight - this.offsetHeight
        ) {
          T = document.documentElement.clientHeight - this.offsetHeight;
        }

        moveX = L + "px";
        moveY = T + "px";
        this.style.left = moveX;
        this.style.top = moveY;
      });
      motion.addEventListener("touchend", function (e) {
        if (flag === 0) {
          e.preventDefault();
          /*
						点击处理事件.....
						*/
          _this.isLgoOpacity = false;
          _this.$store.dispatch("IsUserInfoMaskFun", true);
        }
      });
    },

    //复制公众
    copy() {
      let _this = this;
      let btn = this.$refs.btn;
      var clipboard = new Clipboard(btn);
      clipboard.on("success", function (e) {
        _this.$toast.text("已复制");
      });
    },
    //获取可视区宽高
    getSize() {
      var _this = this;
      let root = document.documentElement;
      let clientWidth = root.clientWidth; //获取客户端宽度
      let clientHeight = root.clientHeight; //获取客户端宽度
      let k = root.clientWidth > root.clientHeight ? 1334 : 750;
      //如果是移动端
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        root.style.width = "";
        var size = window.getComputedStyle(
          document.getElementsByTagName("html")[0]
        ).fontSize;
        if (
          size &&
          this.$store.state.wechatType &&
          _this.model == " COLAL10 "
        ) {
          var size = size.split("p")[0];
          if (size * 1.2 < 100 * (clientWidth / k)) {
            //如果当前html的font-size 的1.2倍仍然小于 之前想设置的值，就说明是问题机型，给之前想附的值乘1.25倍，这样他会被系统再次除1.25得到的才是我们想附的值
            root.style.fontSize = 125 * (clientWidth / k) + "px";
          }
        } else if (
          clientWidth / clientHeight >= 0.75 &&
          clientWidth / clientHeight <= 1 &&
          clientWidth > 600
        ) {
          root.style.fontSize = 100 * (clientWidth / k / 2) + "px";
        } else if (
          clientWidth / clientHeight > 1 &&
          clientWidth / clientHeight <= 1.4 &&
          clientWidth < 750
        ) {
          root.style.fontSize = 100 * (clientWidth / 750 / 1) + "px";
        } else if (
          clientWidth / clientHeight > 2.4 &&
          clientWidth / clientHeight < 3
        ) {
          root.style.fontSize = 100 * (clientWidth / k / 1.2) + "px";
        } else if (clientWidth / clientHeight > 3) {
          root.style.fontSize = 100 * (clientWidth / k / 1.4) + "px";
        } else {
          root.style.fontSize = 100 * (clientWidth / k) + "px";
        }
      } else if (
        clientWidth / clientHeight > 0.65 &&
        clientWidth / clientHeight <= 1
      ) {
        root.style.fontSize = 100 * (clientWidth / k / 1.5) + "px";
      } else if (
        clientWidth / clientHeight &&
        clientWidth > 900 &&
        clientWidth < 1180
      ) {
        root.style.fontSize = 100 * (clientWidth / k / 1.6) + "px";
      } else if (clientWidth >= 1180 && clientWidth < 1480) {
        root.style.fontSize = 100 * (clientWidth / k / 2) + "px";
      } else if (clientWidth >= 1480) {
        root.style.fontSize = 100 * (clientWidth / k / 2.5) + "px";
      } else {
        clientWidth = clientWidth > 900 ? 900 : clientWidth;
        root.style.fontSize = 100 * (clientWidth / k) + "px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}

body,
p {
  margin: 0;
  padding: 0;
}

#home {
  flex: 1;
  width: 100%;
  height: 100%;
  @include flex_box(column, none, stretch);
}

/* 遮罩层  */
.maskInfo {
  width: 100%;
  height: 100%;
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.75);
}

.logoIcon {
  width: 50px;
  height: 50px;
  position: fixed;
  top: 25%;
  left: 0;
  opacity: 1;
  @include flex_box(column, center, center);

  img {
    width: 50px;
    height: 50px;
  }
}
.logoIcon_opacity {
  opacity: 0.5;
}

/* safari浏览器引导添加到主屏 */
.safari-float {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 220px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 6px;
  box-sizing: border-box;
  @include flex_box(row, space-between, center);
}

// .isSafari-browser::after {
//   display: block;
//   content: "";
//   position: absolute;
//   top: 100%;
//   left: 50%;
//   transform: translateX(-50%);
//   border-width: 10px;
//   border-style: solid;
//   border-color: rgba(0, 0, 0, 0.6) transparent transparent transparent;
// }

.safari-logo {
  width: 50px;
  height: 50px;
  border-radius: 10px;
}

.safari-tips {
  padding-left: 10px;
  flex: 1;
  display: inline-block;
  @include flex_box(column, center, flex-start);

  p {
    font-size: 14px;
    color: white;
    line-height: 1.5;

    img {
      width: 18px;
      height: 18px;
      margin-left: 4px;
      position: relative;
      top: 4px;
    }
  }
}

.safari-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  @include flex_box(row, center, center);

  img {
    width: 12px;
    height: 12px;
  }
}
// 客服弹窗
.serviceWin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  z-index: 1000;
}
.closeServiceBtn {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.8rem;
  height: 0.8rem;
  @include flex_box(row, center, center);
  img {
    width: 0.4rem;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view8/home.vue